import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function SponsorVideoField({
  value,
  error,
  setValue,
  setError,
  ...rest
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    if (
      newValue !== '' &&
      !/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/.test(
        String(newValue).toLowerCase()
      )
    ) {
      setError(
        'Video link is not a valid URL (must include http(s):// prefix)'
      );
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          {...rest}
          label='Video Link'
          id='video'
          aria-describedby='video-helper-text'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          variant='standard'
        />
        {error ? (
          <FormHelperText id='video-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='video-helper-text'>
            Enter YouTube/Vimeo link of the sponsor overview.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
